import { useState } from 'react'
import { Grid, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Filter, PaginationButtons, PaginationContext } from 'src/components'
import { useFilter, usePagination } from 'src/hooks'

import { sortToObject } from 'src/common/utils'

import { RedirectURLTable } from './table'
import { RedirectURLsGrid } from './grid'
import {
  initialRedirectURLsFilter,
  useRedirectURLs,
} from '../../../src/hooks/redirect-urls/use-redirect-urls.hook'

const RedirectUrlsTable = () => {
  const defaultSort = 'updated_at-desc'
  const defaultPage = 0
  const defaultLimit = 50

  const [t] = useTranslation()
  const [sort, setSort] = useState(defaultSort)
  const { page, rowsPerPage, setPage, setRowsPerPage } = usePagination(defaultPage, defaultLimit)
  const [filter, setFilter] = useFilter({ initialState: initialRedirectURLsFilter })
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const { data: urls } = useRedirectURLs({ ...filter, ...sortToObject(sort) })

  const paginationValues = {
    count: urls?.count ?? 0,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    isShown: !!urls && urls.count > defaultLimit,
  }

  return (
    <Grid container>
      <>
        <Filter
          searchFieldText={t('search-input-placeholder.v')}
          filter={filter}
          setFilter={setFilter}
          selectionOptions={[]}
          initialState={initialRedirectURLsFilter}
        />
        <PaginationContext.Provider value={paginationValues}>
          {isTablet ? (
            <RedirectURLsGrid items={urls?.data || []} />
          ) : (
            <RedirectURLTable
              sort={sort}
              setSort={setSort}
              items={urls?.data || []}
              setFilter={setFilter}
              filter={filter}
            />
          )}
          {!isTablet && <PaginationButtons />}
        </PaginationContext.Provider>
      </>
    </Grid>
  )
}

export { RedirectUrlsTable }
